export type RuntimeOverrideField = "backend" | "gateway" | "embassy";

export type RuntimeProfile = {
  id: string;
  label: string;
  backend: string;
  gateway: string;
  embassy: string;
};

export const RUNTIME_BACKEND_OPTIONS = [
  "/backend/",
  "/backend/acr1/",
  "/backend/acr2/",
  "/backend/acr3/",
  "/backend/crs1/",
  "/backend/crs2/",
  "/backend/domains1/"
] as const;

export const RUNTIME_GATEWAY_OPTIONS = [
  "/",
  "/acr1/",
  "/acr2/",
  "/acr3/",
  "/crs1/",
  "/crs2/",
  "/domains1/"
] as const;

export const RUNTIME_EMBASSY_OPTIONS = [
  "/embassy/superpanel/",
  "/acr/embassy/acr/",
  "/domains/embassy/domains/",
  "/platforms/embassy/platforms/",
  "/crs/embassy/crs/",
  "/bll/embassy/bll/"
] as const;

export const RUNTIME_PROFILES: RuntimeProfile[] = [
  {
    id: "default",
    label: "Default (colo)",
    backend: "/backend/",
    gateway: "/",
    embassy: "/embassy/superpanel/"
  },
  {
    id: "acr1",
    label: "ACR1",
    backend: "/backend/acr1/",
    gateway: "/acr1/",
    embassy: "/acr/embassy/acr/"
  },
  {
    id: "acr2",
    label: "ACR2",
    backend: "/backend/acr2/",
    gateway: "/acr2/",
    embassy: "/acr/embassy/acr/"
  },
  {
    id: "acr3",
    label: "ACR3",
    backend: "/backend/acr3/",
    gateway: "/acr3/",
    embassy: "/acr/embassy/acr/"
  },
  {
    id: "crs1",
    label: "CRS1",
    backend: "/backend/crs1/",
    gateway: "/crs1/",
    embassy: "/crs/embassy/crs/"
  },
  {
    id: "crs2",
    label: "CRS2",
    backend: "/backend/crs2/",
    gateway: "/crs2/",
    embassy: "/crs/embassy/crs/"
  },
  {
    id: "domains1",
    label: "Domains1",
    backend: "/backend/domains1/",
    gateway: "/domains1/",
    embassy: "/domains/embassy/domains/"
  }
];

const OPTIONS_BY_FIELD: Record<RuntimeOverrideField, readonly string[]> = {
  backend: RUNTIME_BACKEND_OPTIONS,
  gateway: RUNTIME_GATEWAY_OPTIONS,
  embassy: RUNTIME_EMBASSY_OPTIONS
};

export function isAllowedRuntimeValue(
  field: RuntimeOverrideField,
  value: string
): boolean {
  return OPTIONS_BY_FIELD[field].includes(value);
}

export function findProfileByBackend(
  backend: string
): RuntimeProfile | undefined {
  return RUNTIME_PROFILES.find(profile => profile.backend === backend);
}

export function findMatchingProfile(
  backend: string,
  gateway: string,
  embassy: string
): RuntimeProfile | undefined {
  return RUNTIME_PROFILES.find(
    profile =>
      profile.backend === backend &&
      profile.gateway === gateway &&
      profile.embassy === embassy
  );
}
